"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.update = exports.create = exports.fetchPending = exports.fetchLastSuccess = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const purschaseOrderService_1 = require("./service/purschaseOrderService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/fetch', (params, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.fetchSubscriptionPurchaseOrderService(params);
        return response;
    }
    catch (error) {
        throw new Error("Error while fetching subscription purchase order service");
    }
}));
exports.fetchLastSuccess = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/fetchLastSuccess', (params, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.fetchSubscriptionPurchaseOrderService(params);
        return response;
    }
    catch (error) {
        throw new Error("Error while fetching subscription purchase order service");
    }
}));
exports.fetchPending = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/fetchPending', (params, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.fetchSubscriptionPurchaseOrderService(params);
        return response;
    }
    catch (error) {
        throw new Error("Error while fetching subscription purchase order service");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/create', (params, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.createSubscriptionPurchaseOrderService(params);
        return response;
    }
    catch (error) {
        throw new Error("Error while creating subscription purchase order service");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/update', (params, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.updateSubscriptionPurchaseOrderService(params);
        return response;
    }
    catch (error) {
        throw new Error("Error while updating subscription purchase order service");
    }
}));
exports.cancel = (0, toolkit_1.createAsyncThunk)('subscriptionPurchaseOrderService/cancel', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let subscriptionPurchaseOrderService = new purschaseOrderService_1.SubscriptionPlanService(Env_1.APIPATHENV);
        const response = yield subscriptionPurchaseOrderService.cancelSubscriptionPurchaseOrderService();
        return response;
    }
    catch (error) {
        throw new Error("Error while cancelling subscription purchase order service");
    }
}));
